module.exports = __webpack_public_path__ + "img/nav5.7676f010.png";